import React, { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import Routes from 'routes';
import GlobalStyle from 'styles/global';
import history from 'services/browserhistory';
import { AppContext } from 'hooks/contextLib';
import { Group, IOptions } from './utils/commonInterfaces';
import BackToTop from 'components/BackToTop';
import api from './services/api-aws-amplify';
import { apiRoutes } from './utils/defaultValues';
import { Company } from './pages/Company/interfaces';

const App: React.FC = () => {
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [userAuthenticated, setUserAuthenticated] = useState(null);
  const [groups, setGroups] = useState<Group[]>([]);
  const [users, setUsers] = useState<IOptions[]>([]);
  const [companies, setCompanies] = useState<IOptions[]>([]);
  const [userCompanyId, setUserCompanyId] = useState<string>();
  const [companySelected, setCompanySelected] = useState<Company>(
    {} as Company
  );
  const [loading, setLoading] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    onLoad();
  }, []);

  const onLoad = async () => {
    const resp = await api.get(`${apiRoutes.companies}/all`);
    setCompanies(resp.data);
  };

  const value = {
    isAuthenticated,
    userHasAuthenticated,
    userAuthenticated,
    setUserAuthenticated,
    collapsed,
    setCollapsed,
    groups,
    setGroups,
    users,
    setUsers,
    width,
    setWidth,
    companies,
    setCompanies,
    companySelected,
    setCompanySelected,
    userCompanyId,
    setUserCompanyId,
    loading,
    setLoading
  } as any;

  return (
    <AppContext.Provider value={value}>
      <Router history={history}>
        <Routes />
        <BackToTop />
        <GlobalStyle />
      </Router>
    </AppContext.Provider>
  );
};

export default App;
